import classNames from "classnames";
import Head from "next/head";
import React from "react";

import Header from "../../src/components/Header";
import DataSharingModal from "../views/DataSharingModal";

import css from "./Layout.module.scss";

interface LayoutProps extends React.HTMLProps<HTMLElement> {
  onClose?: () => void;
  title?: string;
  headerChildren?: React.ReactNode;
  containerChildren?: React.ReactNode;
  children: React.ReactNode;
}

const Layout = React.forwardRef<HTMLDivElement, LayoutProps>(function Layout(
  {
    title,
    containerChildren,
    headerChildren,
    children,
    className,
    onClose,
    ...rest
  },
  ref
) {
  return (
    <>
      <Head>
        <title>{title ? `${title} | ` : ""}Mosaic Lent Guide</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div {...rest} className={classNames(className, css.container)} ref={ref}>
        <Header title={title || "Mosaic Lent Guide"} onClose={onClose}>
          {headerChildren}
        </Header>
        <main
          className={classNames("relative bg-white overflow-hidden", css.main)}
        >
          {children}
        </main>
        {containerChildren}
      </div>
    </>
  );
});

export default Layout;
